import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { FullUserFragment } from 'graphql.generated';

import { LocationType } from '../../global.constants';
import { AdditionalContactEditorField, CustomerEditorField } from '../../job/job-create/job-create-customer/job-create-customer.state';
import { ActionSource } from '../../state/action-sources';

export const NewOpportunityCustomerActions = createActionGroup({
	source: ActionSource.NEW_OPPORTUNITY_CUSTOMER,
	events: {
		'Clear Customer Button Clicked': emptyProps(),
		'Customer Type Selected': props<{ customerType: string }>(),
		'Referral Source Selected': props<{ referralSource: string }>(),
		'Job Origin Selected': props<{ jobOrigin: string }>(),
		'Full Name Input Changed': props<{
			value: string;
		}>(),
		'Email Input Changed': props<{
			value: string;
		}>(),
		'Phone Input Changed': props<{
			value: string;
		}>(),
		'Company Input Changed': props<{
			value: string;
		}>(),
		'Customer Autocomplete Input Changed': props<{
			field: string;
			value: string;
			key?: string;
		}>(),
		'Customer Autocomplete Search Fired': props<{
			query: string;
			field: CustomerEditorField;
		}>(),
		'Customer Autocomplete Input Focused': props<{
			field: CustomerEditorField;
		}>(),
		'Customer Autocomplete Input Blur': props<{
			field: CustomerEditorField;
		}>(),
		'Existing Customer Selected': props<{
			existingCustomer: FullUserFragment;
		}>(),
		'Google Autocomplete Input Changed': props<{
			address: string;
			locationType: string;
		}>(),
		'Google Autocomplete Address Selected': props<{
			address: google.maps.places.PlaceResult;
			locationType: string;
			openWizard?: boolean;
		}>(),
		'Unit Number Entered': props<{
			unitNumber: string;
			locationType: LocationType;
		}>(),
		'Different Billing Address Checkbox Clicked': props<{ checked: boolean }>(),

		'Add Additional Contact Button Clicked': emptyProps(),
		'Additional Contact Field Changed': props<{
			index: number;
			field: AdditionalContactEditorField;
			value: string;
		}>(),
		'Remove Additional Contact Button Clicked': props<{ index: number }>(),
		'Existing Additional Contact Selected': props<{
			index: number;
			existingContact: FullUserFragment;
		}>(),
		'Additional Contact Edit Mode Changed': props<{
			index: number;
			isEditMode: boolean;
		}>(),

		'Use End Location As Billing Location Checkbox Clicked': props<{ checked: boolean }>(),
	},
});
